module.exports = __webpack_public_path__ + "media/images/icon__profile@3x-46fca395081e33569dbdeeab3bfcbb80.png";